var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modalRef",
      attrs: {
        title: _vm.$t("Verificação de segurança"),
        centered: "",
        "no-close-on-backdrop": "",
        "no-close-on-esc": "",
        "ok-title": _vm.$t("Verificar"),
        "cancel-title": _vm.$t("Cancelar"),
        "ok-disabled": !_vm.isCodeValid || _vm.loading,
        "dialog-class": "reward-code-verification-modal",
        "hide-header-close": true,
      },
      on: {
        ok: function ($event) {
          $event.preventDefault()
          return _vm.onVerify($event)
        },
        cancel: _vm.onCancel,
        close: _vm.onCancel,
        hidden: _vm.hideKeyboard,
        shown: _vm.onModalShown,
      },
    },
    [
      _c("div", { staticClass: "verification-container" }, [
        _c("div", { staticClass: "verification-message mb-4" }, [
          _c("p", { staticClass: "text-center text-muted mb-0" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.customerEmail
                    ? "Digite o código de verificação enviado por notificação no celular cadastrado e para o e-mail " +
                        _vm.customerEmail +
                        '. Se preferir, abra o app echope e acesse "Perfil > Segurança > Código de Verificação" para obter o código.'
                    : ""
                ) +
                " "
            ),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "code-input-wrapper" },
          [
            _c(
              "b-form-group",
              {
                staticClass: "mb-0",
                attrs: {
                  label: "Código de Verificação",
                  "label-for": "verification-code",
                },
              },
              [
                _c("b-form-input", {
                  ref: "codeInput",
                  staticClass: "text-center code-input",
                  attrs: {
                    id: "verification-code",
                    type: "text",
                    inputmode: "numeric",
                    maxlength: "4",
                    placeholder: "____",
                    autocomplete: "off",
                  },
                  on: {
                    input: _vm.onCodeInput,
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.onVerify($event)
                    },
                    focus: _vm.onInputFocus,
                  },
                  model: {
                    value: _vm.verificationCode,
                    callback: function ($$v) {
                      _vm.verificationCode = $$v
                    },
                    expression: "verificationCode",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c("div", { staticClass: "resend-code-section" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-link btn-sm text-muted",
              attrs: { type: "button", disabled: _vm.resendCodeLoading },
              on: { click: _vm.onResendCode },
            },
            [
              !_vm.resendCodeLoading
                ? _c("span", [_vm._v(" Reenviar código ")])
                : _c(
                    "span",
                    [
                      _c("b-spinner", { attrs: { small: "" } }),
                      _vm._v(" Reenviando... "),
                    ],
                    1
                  ),
            ]
          ),
        ]),
        _vm.errorMessage
          ? _c(
              "div",
              {
                staticClass: "alert alert-danger mt-3 mb-0",
                attrs: { role: "alert" },
              },
              [_vm._v(" " + _vm._s(_vm.errorMessage) + " ")]
            )
          : _vm._e(),
        _vm.successMessage
          ? _c(
              "div",
              {
                staticClass: "alert alert-success mt-3 mb-0",
                attrs: { role: "alert" },
              },
              [_vm._v(" " + _vm._s(_vm.successMessage) + " ")]
            )
          : _vm._e(),
        _vm.loading
          ? _c(
              "div",
              { staticClass: "text-center mt-3" },
              [
                _c("b-spinner", {
                  attrs: {
                    label: "Verificando código...",
                    type: "border",
                    variant: "primary",
                    small: "",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }